import config from '@/config'

type Dimension = string | number
type Size = string | null

export type ImageOptions = {
  width?: Dimension
  height?: Dimension
  fit?: Size
  type?: Size
  quality?: number | null
}

const getSize = (width?: Dimension, height?: Dimension) => {
  if (!height && !width) return ''
  return `/${width}x${height}`
}

const getValues: (v?: Size, t?: Size) => string = (...values) =>
  values.map(v => (v ? `/${v}` : '')).join('')

export const getImageUrl = (
  src?: string | null,
  { width = '', height = '', fit = null, type = null, quality = 70 }: ImageOptions = {}
) => {
  if (!src) return null
  const match = src.match(/static_file.+$/)

  if (match) {
    const image = match[0].replace(/^\//, '')
    const qualityStr = quality !== null ? `filters:quality(${quality})/` : ''
    return `${config.IMAGES_URL}${getSize(width, height)}${getValues(fit, type)}/${qualityStr}${image}`
  }

  return `${config.IMAGES_URL}${getSize(width, height)}${getValues(fit, type)}/${src}`
}
